import PageMeta from '@/components/base/PageMeta';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';

export default function About() {
  return (
    <>
      <ScrollToTop />
      <PageMeta
        title="关于我们 - 海角社区地址导航"
        description="海角导航致力于为海角社区用户提供最新、最全的官方入口地址、镜像备用链接及访问教程，帮助用户快速稳定地访问海角社区。"
        canonicalUrl="https://haijiao-navi.readdy.ai/about"
        jsonLdScripts={[
          {
            '@context': 'https://schema.org',
            '@type': 'AboutPage',
            name: '关于海角导航',
            description: '海角导航致力于为海角社区用户提供最新、最全的官方入口地址、镜像备用链接及访问教程。',
            url: 'https://haijiao-navi.readdy.ai/about',
            isPartOf: {
              '@type': 'WebSite',
              name: '海角社区地址导航',
              url: 'https://haijiao-navi.readdy.ai/',
            },
          },
        ]}
      />

      <Navbar />
      <Breadcrumb />

      <main>
        <section className="py-10 md:py-14 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6 text-center">
            <h1 className="font-heading text-3xl md:text-4xl font-bold text-foreground-950 mb-3">
              关于我们
            </h1>
            <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto leading-relaxed">
              海角导航——您身边的海角社区入口导航助手
            </p>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
              品牌介绍
            </h2>
            <div className="space-y-4 text-foreground-700 leading-relaxed">
              <p>
                海角导航（haijiao-navi）是一个专注于<strong>海角社区地址</strong>信息整理与分享的导航平台。我们深知用户在访问海角社区时经常遇到地址失效、入口变更等问题，因此创建了本站，旨在为广大用户提供一站式的地址导航服务。
              </p>
              <p>
                本站持续追踪和验证<strong>海角社区最新地址</strong>，包括官方主入口、镜像备用链接等多条访问线路。所有地址信息均经过人工验证，确保真实可用。您可以放心通过本站的导航链接访问海角社区。
              </p>
              <p>
                除了地址导航服务外，我们还提供详尽的<strong>海角社区访问教程</strong>，涵盖新手指南、移动端优化、故障排除等内容，帮助不同技术水平的用户都能轻松上手使用海角社区。
              </p>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-10 text-center">
              我们的口碑
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              <div className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-accent-100 text-accent-600">
                  <i className="ri-shield-check-line text-2xl"></i>
                </div>
                <div className="text-3xl font-bold text-accent-500 font-heading mb-2">100%</div>
                <p className="text-sm text-foreground-600">人工验证地址</p>
                <p className="text-xs text-foreground-500 mt-1">所有地址发布前均经人工实测</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-primary-100 text-primary-600">
                  <i className="ri-time-line text-2xl"></i>
                </div>
                <div className="text-3xl font-bold text-primary-500 font-heading mb-2">7×24</div>
                <p className="text-sm text-foreground-600">持续更新监测</p>
                <p className="text-xs text-foreground-500 mt-1">地址变更后第一时间更新</p>
              </div>
              <div className="text-center p-6 rounded-lg bg-background-50 border border-background-200/70">
                <div className="w-14 h-14 mx-auto mb-4 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-700">
                  <i className="ri-user-heart-line text-2xl"></i>
                </div>
                <div className="text-3xl font-bold text-secondary-600 font-heading mb-2">50,000+</div>
                <p className="text-sm text-foreground-600">累计服务用户</p>
                <p className="text-xs text-foreground-500 mt-1">帮助数万用户顺利访问海角社区</p>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-50">
          <div className="max-w-4xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-6">
              我们的使命
            </h2>
            <div className="space-y-4 text-foreground-700 leading-relaxed">
              <p>
                我们的使命很简单：<strong>让每一位海角社区用户都能快速、稳定地找到可用入口</strong>。无论您是社区的老用户还是新朋友，无论您身处何地、使用何种设备，海角导航都为您准备了最便捷的访问方案。
              </p>
              <p>
                我们坚持免费提供服务，不向用户收取任何费用。本站通过整理和分享公开的地址信息来帮助用户，所有内容仅供学习交流参考。请用户遵守相关法律法规，合理使用网络资源。
              </p>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-background-100" id="contact">
          <div className="max-w-2xl mx-auto px-4 md:px-6">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3 text-center">
              联系我们
            </h2>
            <p className="text-sm text-foreground-600 text-center mb-10">
              如发现地址失效或有任何建议，欢迎通过以下表单联系我们
            </p>

            <ContactForm />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
}

function ContactForm() {
  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;

    const formData = new FormData(form);
    const honeypotValue = (formData.get('phone_alt') as string || '').trim();
    if (honeypotValue) {
      const successEl = document.getElementById('contact-form-success');
      if (successEl) successEl.classList.remove('hidden');
      form.reset();
      return;
    }

    formData.delete('phone_alt');

    const formErrorEl = document.getElementById('contact-form-error');
    if (formErrorEl) formErrorEl.classList.add('hidden');
    const formSuccessEl = document.getElementById('contact-form-success');
    if (formSuccessEl) formSuccessEl.classList.add('hidden');

    try {
      const response = await fetch('https://readdy.ai/api/form/d9qr2gue3oq4jqumtpag', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData as unknown as Record<string, string>).toString(),
      });

      const responseText = await response.text();
      let parsed;
      try { parsed = JSON.parse(responseText); } catch { parsed = null; }

      if (response.ok && parsed?.code === 'OK') {
        if (formSuccessEl) formSuccessEl.classList.remove('hidden');
        form.reset();
      } else {
        const serverMsg = parsed?.meta?.message || parsed?.message || parsed?.meta?.detail || responseText || '提交失败，请稍后重试';
        if (formErrorEl) {
          formErrorEl.textContent = serverMsg;
          formErrorEl.classList.remove('hidden');
        }
      }
    } catch {
      if (formErrorEl) {
        formErrorEl.textContent = '网络错误，请检查网络后重试';
        formErrorEl.classList.remove('hidden');
      }
    }
  };

  return (
    <form onSubmit={handleSubmit} data-readdy-form="" className="space-y-5">
      <div id="contact-form-error" className="hidden bg-accent-100 border border-accent-300 text-accent-800 rounded-lg p-4 text-sm"></div>
      <div id="contact-form-success" className="hidden bg-primary-100 border border-primary-300 text-primary-800 rounded-lg p-4 text-sm">
        感谢您的留言！我们会尽快处理并回复。
      </div>

      <div>
        <label htmlFor="contact-name" className="block text-sm font-medium text-foreground-800 mb-1.5">您的姓名</label>
        <input
          type="text"
          id="contact-name"
          name="name"
          required
          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
          placeholder="请输入您的姓名"
        />
      </div>

      <div>
        <label htmlFor="contact-email" className="block text-sm font-medium text-foreground-800 mb-1.5">电子邮箱</label>
        <input
          type="email"
          id="contact-email"
          name="email"
          required
          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
          placeholder="请输入您的邮箱地址"
        />
      </div>

      <div>
        <label htmlFor="contact-subject" className="block text-sm font-medium text-foreground-800 mb-1.5">主题</label>
        <input
          type="text"
          id="contact-subject"
          name="subject"
          required
          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all"
          placeholder="请选择主题"
        />
      </div>

      <div>
        <label htmlFor="contact-message" className="block text-sm font-medium text-foreground-800 mb-1.5">留言内容</label>
        <textarea
          id="contact-message"
          name="message"
          required
          maxLength={500}
          rows={5}
          className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-foreground-900 text-sm focus:outline-none focus:border-primary-400 focus:ring-2 focus:ring-primary-100 transition-all resize-none"
          placeholder="请详细描述您遇到的问题或建议（最多500字）"
        ></textarea>
        <p className="text-xs text-foreground-500 mt-1">最多可输入500个字符</p>
      </div>

      <div className="honeypot-field" aria-hidden="true">
        <input type="text" name="phone_alt" tabIndex={-1} autoComplete="off" readOnly />
      </div>

      <button
        type="submit"
        className="w-full py-3 bg-primary-500 hover:bg-primary-600 text-white rounded-lg font-medium transition-all duration-300 whitespace-nowrap cursor-pointer text-sm"
      >
        提交留言
      </button>
    </form>
  );
}